export enum MenuItemType {
  Parent,
  Group,
  Item,
  CustomItem,
}
